import { Injectable } from '@angular/core';

export interface ValidationResult {
  hasNumber: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasSpecialCharacter: boolean;
  isLongEnough: boolean;

  allRulesAreSatisfied?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PasswordValidatorService {
  private readonly minLength = 8;

  private numberExpression: RegExp = /\d/;
  private uppercaseExpression: RegExp = /[ÆØÅA-Z]/;
  private lowercaseExpression: RegExp = /[æøåa-z]/;
  private specialCharacterExpression: RegExp = /[\!\@\#\$\%\^\&\*\)\(\+\=\.\<\>\{\}\[\]\:\;\'\"\|\~\`\_\-]/;

  public isValid(password: string): ValidationResult {
    const result: ValidationResult = {
      isLongEnough: this.isLongEnough(password),
      hasNumber: this.hasNumber(password),
      hasUppercase: this.hasUppercase(password),
      hasLowercase: this.hasLowercase(password),
      hasSpecialCharacter: this.hasSpecialCharacter(password)
    };

    result.allRulesAreSatisfied = result.isLongEnough && result.hasNumber && result.hasUppercase && result.hasLowercase && result.hasSpecialCharacter;

    return result;
  }

  private isLongEnough(password: string): boolean {
    return password?.length >= this.minLength;
  }

  private hasNumber(password: string): boolean {
    return this.numberExpression.test(password);
  }

  private hasUppercase(password: string): boolean {
    return this.uppercaseExpression.test(password);
  }

  private hasLowercase(password: string): boolean {
    return this.lowercaseExpression.test(password);
  }

  private hasSpecialCharacter(password: string): boolean {
    return this.specialCharacterExpression.test(password);
  }
}
